<template>
	<modal
		size="small-medium"
		:hide-footer="true"
		@close="close">
		<template slot="header">
			<span v-if="!data">{{ $t('Add Package') }}</span>
			<span v-else>{{ $t('Edit Package') }}</span>
		</template>
		<template slot="body">
			<div
				class="package-picture mb-3"
				:style="{ backgroundImage: `url('${picture}')` }">
				<h2 text-black v-if="!picture || picture === ' '" class="pt-5 text-center">{{$t('Upload your Image')}}</h2>
			</div>
			<div class="d-flex justify-content-between mb-3">
				<label
					:class="{ 'is-loading': isUploadingPicture}"
					class="btn btn-default mr-3 mb-0"
					v-tooltip="'Change Package Picture'">
					{{$t('Upload')}}
					<input
						accept=".png,.gif,.jpeg,.jpg"
						type="file"
						class="hidden"
						@change="onSelectPicture"
					/>
				</label>
				<button
					role="button"
					class="btn btn-default btn-icon pr-0 mr-0"
					:class="{ 'is-loading': isRemovingPicture }"
					v-tooltip="'Remove Package Picture'"
					@click="removePicture">
					<i class="material-icons md-18">delete</i>
				</button>
			</div>
			<form @submit.prevent="save">
				<!-- name -->
				<div class="form-group">
					<label>{{ $t('Name') }}</label>
					<input type="text" name="name" class="form-control" v-model="name" required @keydown="textKeydown($event)">
				</div>
				<!-- Length -->
				<div class="d-flex">
					<div class="form-group col-lg-6 pl-0">
						<label>{{ $t('Length') }}</label>
						<input type="number" name="length" class="form-control" v-model="length" required>
					</div>
					<!-- type Length -->
					<div class="form-group col-lg-6 pr-0 pb-0 mb-0">
						<label class="mb-0 pb-0">{{ $t('Period') }}</label>
						<div>
							<MdRadio class="type-length-package md-primary" v-model="lengthType" value="day">{{$t('Day')}}</MdRadio>
							<MdRadio class="type-length-package md-primary" v-model="lengthType" value="month">{{$t('Month')}}</MdRadio>
						</div>
					</div>
				</div>
				<!-- Description -->
				<div class="form-group">
					<label>{{ $t('Description') }}</label>
					<input type="text" name="description" class="form-control" v-model="description" required @keydown="textKeydown($event)">
				</div>
				<!-- Input slug url -->
				<div class="form-group">
					<label>{{ $t('Slug URL') }} (optional)</label>
					<input type="text" name="slugURL" class="form-control" v-model="uid" @keydown="codeKeydown($event)">
					<span class="text-secondary text-small">Only users who have this URL can see the package</span>
				</div>
				<!-- type -->
				<div class="form-group mb-0 pb-0 mb-0">
					<label class="mb-0 pb-0">{{ $t('Type') }}</label>
					<div>
						<MdRadio class="type-length-package md-primary" v-model="type" value="subscription">{{$t('Subscription')}}</MdRadio>
						<MdRadio class="type-length-package md-primary" v-model="type" value="one_time">{{$t('Feature')}}</MdRadio>
						<MdRadio class="type-length-package md-primary" v-model="type" value="non_feature">{{$t('Non Feature')}}</MdRadio>

					</div>
				</div>
				<div class="d-flex">
					<!-- Price -->
					<div class="form-group col-lg-6 pl-0">
						<label>{{ $t('Price in USD') }}</label>
						<input type="number" name="price" class="form-control" v-model="price" required>
					</div>
					<!-- Purchase Limit -->
					<div class="form-group col-lg-6 pr-0">
						<label>{{ $t('Purchase Limit ') }}({{ $t('\'0\' for unlimited') }})</label>
						<input type="number" name="purchaseLimit" class="form-control" v-model="purchaseLimit" required>
					</div>
					<!-- Discount -->
					<!-- <div class="form-group col-lg-6 pr-0">
						<label>{{ $t('Discount') }}</label>
						<input type="number" name="discount" class="form-control" v-model="discount" required>
					</div> -->
				</div>
				<!-- Is Published -->
				<div class="d-flex">
					<label class="custom-control custom-checkbox mb-3 mr-4">
						<input type="checkbox" class="custom-control-input" v-model="isPublished">
						<span class="custom-control-label pt-1">{{ $t('Published') }}</span>
					</label>
					<!-- Is Apply User -->
					<!-- <label class="custom-control custom-checkbox mb-3" v-if="data">
						<input type="checkbox" class="custom-control-input" v-model="isApplyUsers">
						<span class="custom-control-label pt-1">{{ $t('Apply to all Users') }}</span>
					</label> -->
					<!-- Is Apply User -->
					<label class="custom-control custom-checkbox mb-3" v-if="type === 'subscription'">
						<input type="checkbox" class="custom-control-input" v-model="isRenew">
						<span class="custom-control-label pt-1">{{ $t('Auto Renew') }}</span>
					</label>
				</div>
				<!-- Submit -->
				<button v-if="!data"
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving, 'disabled': isUploadingPicture }">
					{{ $t('Create Package') }}
				</button>
				<button v-else
					type="submit"
					class="btn btn-submit btn-primary mt-3"
					:class="{ 'is-loading': isSaving, 'disabled': isUploadingPicture }">
					{{ $t('Update Package') }}
				</button>
			</form>
		</template>
	</modal>
</template>

<script>
import localforage from 'localforage';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';
import packagesApi from '@/api/packages';
import fileApi from '@/api/file';

export default {
	name: 'FeatureForm',
	props: {
		data: {
			type: Object,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			name: '',
			description: '',
			length: '',
			lengthType: 'day',
			type: 'subscription',
			purchaseLimit: 0,
			price: '',
			discount: '',
			isPublished: '',
			picture: '',
			uid: '',
			isRemovePictureVisible: false,
			isUploadingPicture: false,
			isRemovingPicture: false,
			isSaving: false,
			isApplyUsers: true,
			isRenew: true,
		};
	},
	methods: {
		onSelectPicture(e) {
			const files = e.target.files;
			if (files.length > 0) {
				if (files[0].type === 'image/jpeg' || files[0].type === 'image/gif' || files[0].type === 'image/png' || files[0].type === 'image/jpg') {
					this.isUploadingPicture = true;
					const file = files[0];
					if (!file) {
						this.$notify({
							group: 'app',
							type: 'warn',
							title: 'Upload File',
							text: 'Sorry, currently we cant upload the file',
						});
						return;
					}
					const params = new FormData();
					params.append('file', file);
					const callback = (response) => {
						const picture = response.data;
						this.picture = picture;
						this.updatePicture();
						this.isUploadingPicture = false;
					};
					const errorCallback = () => {
						this.isUploadingPicture = false;
					};
					fileApi.upload(params, callback, errorCallback);

					this.pictureFile = file;
					// Read image for preview
					const reader = new FileReader();
					reader.onload = (e) => {
						this.picture = e.target.result;
					};
					reader.readAsDataURL(file);
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		removePicture() {
			this.picture = '';
			this.updatePicture();
			this.isRemovePictureVisible = false;
		},
		updatePicture() {
			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Update Picture',
					text: message,
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Update Picture',
					text: message,
				});
			};
			packagesApi.update(this.data.id, callback, errorCallback);
		},
		save() {
			this.isSaving = true;
			const params = this.params;
			const callback = (response) => {
				const item = response.data;
				const message = response.message;
				this.$emit('saved', item);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Package',
					text: message,
				});
				this.isSaving = false;
				this.close();
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Package',
					text: message,
				});
				this.isSaving = false;
			};
			if (this.data) {
				localforage.removeItem(`hidden_package_${this.data.id}`);
				packagesApi.update(this.data.id, params, callback, errorCallback);
			} else {
				packagesApi.create(params, callback, errorCallback);
			}
		},
		close() {
			this.$emit('close');
		},
		initData() {
			this.reset();
			if (this.data) {
				this.setData(this.data);
			}
		},
		reset() {
			this.name = '';
			this.description = '';
			this.length = '';
			this.lengthType = 'day';
			this.type = 'subscription';
			this.purchaseLimit = 0;
			this.price = '';
			this.discount = '';
			this.isPublished = '';
			this.picture = '';
			this.isRenew = true;
			this.uid = '';
		},
		setData(data) {
			this.name = data.name;
			this.type = data.type;
			this.description = data.description;
			this.length = data.length;
			this.lengthType = data.length_type;
			this.purchaseLimit = data.purchase_limit;
			this.price = data.price;
			this.discount = data.discount;
			this.isPublished = data.is_published;
			this.picture = data.file_path;
			this.isRenew = data.is_auto_renew;
			this.uid = data.uid;
		},
		textKeydown(e) {
			if (/[^A-Z0-9 ]/gi.test(e.key)) {
				e.preventDefault();
			}
		},
		codeKeydown(e) {
			if (/[^A-Z0-9]/gi.test(e.key)) {
				e.preventDefault();
			}
		},
	},
	computed: {
		params() {
			const params = {
				name: this.name,
				type: this.type,
				description: this.description,
				length: this.length,
				length_type: this.lengthType,
				purchase_limit: this.purchaseLimit,
				price: this.price,
				// discount: this.discount,
				is_published: this.isPublished,
				file_path: this.picture,
				is_apply_users: this.isApplyUsers,
			};
			if (this.uid) params.code = this.uid;
			if (this.type === 'subscription') params.is_auto_renew = this.isRenew;
			return params;
		},
	},
	created() {
		this.initData();
	},
};
</script>
